<!--统计报表-油烟减排统计-->
<template>
  <section>
    <!-- 工具条 -->
    <el-col :span='24' class='toolbar' style='padding-bottom: 0px;'>
      <el-form :inline='true' :model='filter' size="mini">
        <el-form-item>
          <el-input
            v-model.trim="filter.name"
            placeholder="编码"
            @keyup.native.enter.stop="handleFilterChange"
          >
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-cascader
            v-model="filter.owner"
            placeholder="所属单位"
            :options="customerTree"
            :props="orgProps"
            @change="handleFilterChange"
            clearable
            filterable/>
        </el-form-item>
        <el-form-item>
            <el-select
              value-key="Id"
              @change="handleFilterChange"
              v-model="filter.maintainerId"
              filterable
              clearable
              placeholder='运维人员'>
              <el-option
                v-for="item in maintainerList"
                :key="item.Id"
                :label="item.Name"
                :value="item.Id"
              ></el-option>
            </el-select>
          </el-form-item>
        <el-form-item>
          <el-date-picker
              v-model="filter.peorid"
              type="daterange"
              @change="handleFilterChange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="timestamp"
              :default-time="['00:00:00', '23:59:59']">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-cascader
          placeholder="运维单类型"
          v-model="selectFilter"
          :options="options"
          :props="pro"
          collapse-tags
          :show-all-levels="false"
          @change="handleFilterChange"></el-cascader>
        </el-form-item>
        <el-form-item>
          <el-button type='primary' @click='getData'>查询</el-button>
          <el-button type='primary' @click='openExportSizeInput'>导出</el-button>
        </el-form-item>
      </el-form>
    </el-col>
    <!-- 列表 -->
    <el-col :span='24'>
      <el-table :data='datalist' show-summary size='mini' border highlight-current-row v-loading='loading' :max-height='clientHeight' style='width: 100%'>
        <el-table-column type='index' label='#' align='center' width='55'/>
        <el-table-column prop='locale_name' label='监测点' show-overflow-tooltip width='260' header-align='center'/>
        <el-table-column prop='locale_addr' label='安装地址' show-overflow-tooltip width='260' header-align='center'/>
        <el-table-column prop='mn' label='设备编码' show-overflow-tooltip width='180' align='center' header-align='center'/>
        <el-table-column prop='maintainer_name' label='运维人员' width='160' align='center' header-align='center'/>
        <el-table-column prop='total_number' label='运维单总数' width='160' align='center' header-align='center'/>
        <el-table-column prop='finish_per' label='完成率' width='160' align='center' header-align='center'/>
        <template v-if="showDaily">
          <el-table-column prop='daily_maintainer_number' label='日常运维单数' width='160' align='center' header-align='center'/>
          <el-table-column prop='daily_maintainer_per' label='完成率' width='160' align='center' header-align='center'/>
        </template>
        <template v-if="showAbnormal">
          <el-table-column prop='abnormal_offline_number' label='异常离线运维单数' width='160' align='center' header-align='center'/>
          <el-table-column prop='abnormal_offline_per' label='完成率' width='160' align='center' header-align='center'/>
          <el-table-column prop='abnormal_offline_no_device_per' label='非设备原因占比' width='160' align='center' header-align='center'/>
          <el-table-column prop='abnormal_offline_mark_number' label='标记次数' width='160' align='center' header-align='center'/>
          <el-table-column prop='abnormal_offline_repeat_number' label='3日重复发生次数' width='160' align='center' header-align='center'/>
        </template>
        <template v-if="showDataAbnormal">
          <el-table-column prop='abnormal_data_number' label='数据异常运维单数' width='160' align='center' header-align='center'/>
          <el-table-column prop='abnormal_data_per' label='完成率' width='160' align='center' header-align='center'/>
          <el-table-column prop='abnormal_data_no_device_per' label='非设备原因占比' width='160' align='center' header-align='center'/>
          <el-table-column prop='abnormal_data_mark_number' label='标记次数' width='160' align='center' header-align='center'/>
          <el-table-column prop='abnormal_data_repeat_number' label='3日重复发生次数' width='160' align='center' header-align='center'/>
        </template>
        <template v-if="showDevice">
          <el-table-column prop='device_failure_number' label='设备故障运维单数' width='160' align='center' header-align='center'/>
          <el-table-column prop='device_failure_per' label='完成率' width='160' align='center' header-align='center'/>
          <el-table-column prop='device_failure_no_device_per' label='非设备原因占比' width='160' align='center' header-align='center'/>
        </template>
        <template v-if="showVerify">
          <el-table-column prop='verify_number' label='事件核实数' width='160' align='center' header-align='center'/>
          <el-table-column prop='verify_per' label='完成率' width='160' align='center' header-align='center'/>
        </template>

      </el-table>
    </el-col>

    <!-- 工具条 -->
    <el-col :span='24' class='toolbar'>
      <el-pagination
          background
          @size-change="(v)=>handlePageChange(v, 'size')"
          @current-change="(v)=>handlePageChange(v, 'page')"
          :current-page.sync='filter.page'
          :page-sizes='filter.pageSizes' layout='total, sizes, prev, pager, next, jumper'
          :total='total'
          style='display:inline-block;margin-left:15px'>
      </el-pagination>
    </el-col>
  </section>
</template>

<script>
import {mapState} from 'vuex'
import {ownerJoin,getUserInfo} from '@/util'
import dayjs from "dayjs";

export default {
  data() {
    return {
      loading: false,
      datalist: [],
      maintainerList: [],
      total: 0,
      showDaily: false,
      showDevice: false,
      showVerify: false,
      showAbnormal: false,
      showDataAbnormal: false,
      selectFilter: [
        [1, 2],
        [1, 6],
        [1, 3],
        [1, 9],
        [1, 7],
        [1, 8],
        [1, 10],
        [1, 11],
        [2, '数据漂移'],
        [2, '数据偏小'],
        [2, '数据偏大'],
        [2, '异常离线'],
        [2, '长时间为0'],
        [4, 1],
        [4, 2],
        [4, 3],
        [4, 4],
        [4, 5],
        [4, 6],
        [8, 1],
        [8, 2],
        [8, 4],
      ],
      pro: { multiple: true },
      options: [{
        value: 1,
        label: '日常运维',
        children: [ {
          value: 2,
          label: '移机'
        },
        {
          value: 6,
          label: '维保'
        },
        {
          value: 3,
          label: '拆机'
        },
        {
          value: 9,
          label: '换机'
        },
        {
          value: 7,
          label: '超标巡查'
        },
        {
          value: 8,
          label: '异常离线巡查'
        },
        {
          value: 10,
          label: '例行检查'
        },{
          value: 11,
          label: '数据校准'
        },]
      }, {
        value: 2,
        label: '数据异常',
        children: [{
          label: '数据漂移',
          value: '数据漂移'
        },
        {
          label: '数据偏小',
          value: '数据偏小'
        },
        {
          label: '数据偏大',
          value: '数据偏大'
        },
        {
          label: '异常离线',
          value: '异常离线'
        },
        {
          label: '长时间为0',
          value: '长时间为0'
        }]
      }, {
        value: 4,
        label: '设备异常',
        children: [
          {
          value: 1,
          label: '风机监控异常'
        },
        {
          value: 2,
          label: '净化器监控异常'
        },
        {
          value: 3,
          label: '油烟检测传感异常'
        },
        {
          value: 4,
          label: '油烟监测异常'
        },
        {
          value: 5,
          label: '监控异常'
        },
        {
          value: 6,
          label: '监测仪、风机监控异常'
        }]
      }, {
        value: 8,
        label: '事件核实',
        children: [{
          value: 1,
          label: '红码核实',

        }, {
          value: 2,
          label: '报警核实',

        }, {
          value: 4,
          label: '清洗核实',
        }]
      }],
      filter: {
        peorid: null,
        name: null,
        maintainerId: "",
        page: 1,
        size: 20,
        pageSizes: [20, 30, 50]
      },
    }
  },
  computed: {
    ...mapState(['props', 'customerTree', 'clientHeight']),
    ...mapState({
      orgProps: state => Object.assign({}, state.props, {label: 'Org', checkStrictly: true})
    })
  },
  mounted() {
    this.$get('admin/listMaintainer').then(res => {
      this.maintainerList = res
    })
    var timestamp = new Date(new Date(new Date().toLocaleDateString()).getTime() - 30 * 24 * 3600 * 1000).getTime()
    this.filter.peorid = [timestamp, new Date(new Date().toLocaleDateString()).getTime() + 86399000]
    this.getData()
  },
  methods: {
    openExportSizeInput() {
      this.$prompt(`请输入导出的数据量（总量：${this.total} 条）`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^[0-9]*$/,
        inputErrorMessage: '只能填入数字'
      }).then(({value}) => {
        this.handleExport(parseInt(value))
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消'
        })
      })
    },

    handleExport(size) {
      var daily_filter = []
		  var abnormal_filter = []
      var device_filter = []
      var verify_filter = 0
      for(var i = 0; i < this.selectFilter.length; i++) {
        if (this.selectFilter[i][0] == 1) {
          daily_filter.push(this.selectFilter[i][1])
        }
        if (this.selectFilter[i][0] == 2) {
          abnormal_filter.push(this.selectFilter[i][1])
        }
        if (this.selectFilter[i][0] == 4) {
          device_filter.push(this.selectFilter[i][1])
        }
        if (this.selectFilter[i][0] == 8) {
          verify_filter = verify_filter + this.selectFilter[i][1]
        }
      }
      var from_type = 0
      if (daily_filter.length > 0) {
        from_type = from_type + 1
      }
      if (abnormal_filter.length > 0) {
        from_type = from_type + 2
      }
      if (device_filter.length > 0) {
        from_type = from_type + 4
      }
      if (verify_filter > 0) {
        from_type = from_type + 8
      }
      if (from_type == 0) {
        this.$message({
          showClose: true,
          message: '运维单类型不能为空'
        });
        return
      }
      const param = {
        page: this.filter.page,
        size: size,
        is_download: true,
        from_type: from_type,
        daily_filter: daily_filter.length > 0 ? daily_filter.join(","): "",
        device_filter: device_filter.length > 0 ? device_filter.join(","): "",
        abnormal_filter: abnormal_filter.length > 0 ? abnormal_filter.join(","): "",
        verify_filter: verify_filter,
      }
      if (this.filter.owner && this.filter.owner.length > 0) {
        let userInfo = getUserInfo().Info
        param.owner = `${ownerJoin(this.filter.owner, userInfo)}`
      }
      if (this.filter.peorid) {
        param.start_at = this.filter.peorid[0] / 1000
        param.end_at = this.filter.peorid[1] / 1000
      }
      if (this.filter.name) {
        param.name = this.filter.name
      }
      if (this.filter.maintainerId){
        param.maintainer_id = this.filter.maintainerId
      }
      //定义加载中的动画
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
        target: document.querySelector(".submit-dialog") // .submit-dialog 指的是 el-dialog 的 class
      });
      this.$get("admin/list/locale/maintenance", param).then(res => {
        let url = res.url
        const link = document.createElement('a')
        link.setAttribute('href', url)
        link.click()
        loading.close();
      })
    },
    // 新增方法：处理筛选条件变化
    handleFilterChange() {
      // 筛选条件变化时，重置页码到第一页
      this.filter.page = 1;
      this.getData();
    },
    getData() {
      this.datalist = []
      this.count = 0
      this.loading = true
      var daily_filter = []
		  var abnormal_filter = []
      var device_filter = []
      var verify_filter = 0
      this.showDaily = false
      this.showDevice = false
      this.showVerify = false
      this.showAbnormal =  false
      this.showDataAbnormal = false
      for(var i = 0; i < this.selectFilter.length; i++) {
        if (this.selectFilter[i][0] == 1) {
          daily_filter.push(this.selectFilter[i][1])
        }
        if (this.selectFilter[i][0] == 2) {
          abnormal_filter.push(this.selectFilter[i][1])
        }
        if (this.selectFilter[i][0] == 4) {
          device_filter.push(this.selectFilter[i][1])
        }
        if (this.selectFilter[i][0] == 8) {
          verify_filter = verify_filter + this.selectFilter[i][1]
        }
      }
      var from_type = 0
      if (daily_filter.length > 0) {
        from_type = from_type + 1
        this.showDaily = true
      }
      if (abnormal_filter.length > 0) {
        from_type = from_type + 2
        this.showDataAbnormal = true
        if (abnormal_filter.indexOf('异常离线') > -1) {
          this.showAbnormal = true
        }
      }
      if (device_filter.length > 0) {
        from_type = from_type + 4
        this.showDevice = true
      }
      if (verify_filter > 0) {
        from_type = from_type + 8
        this.showVerify = true
      }
      if (from_type == 0) {
        this.$message({
          showClose: true,
          message: '运维单类型不能为空'
        });
        return
      }
      const param = {
        page: this.filter.page,
        size: this.filter.size,
        from_type: from_type,
        daily_filter: daily_filter.length > 0 ? daily_filter.join(","): "",
        device_filter: device_filter.length > 0 ? device_filter.join(","): "",
        abnormal_filter: abnormal_filter.length > 0 ? abnormal_filter.join(","): "",
        verify_filter: verify_filter,
      }
      if (this.filter.owner && this.filter.owner.length > 0) {
        let userInfo = getUserInfo().Info
        param.owner = `${ownerJoin(this.filter.owner, userInfo)}`
      }
      if (this.filter.peorid) {
        param.start_at = this.filter.peorid[0] / 1000
        param.end_at = this.filter.peorid[1] / 1000
      }
      if (this.filter.name) {
        param.name = this.filter.name
      }
      if (this.filter.maintainerId){
        param.maintainer_id = this.filter.maintainerId
      }
      this.$get("admin/list/locale/maintenance", param).then(res => {
        this.datalist = res.list
        this.total = res.count
        this.$forceUpdate()
      })
      this.loading = false
    },
    // 改变页容量
    selsChange(sels) {
      this.sels = sels
    },
    handlePageChange(val, field) {
      this.filter[field] = val
      this.getData()
    },
  }
}
</script>
